'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetMarket, useGetWinners } from '@morfi/backend-sdk-v2/client';
import type { MarketDetailLayoutProps } from '@/components/market/market-detail-layout';
import { MarketDetailPositionBoundary } from '@/components/market/market-detail-position-boundary';
import { useHeldWhile } from '@/hooks/market/use-held-while';
import { useResolutionHold } from '@/hooks/market/use-resolution-hold';
export function MarketDetailLayout(props) {
  const $ = _c(20);
  let t0;
  if ($[0] !== props.marketPubkey) {
    t0 = {
      pubkey: props.marketPubkey
    };
    $[0] = props.marketPubkey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const marketQuery = useGetMarket(t0);
  const initialMarket = props.initialMarket?.pubkey === props.marketPubkey ? props.initialMarket : undefined;
  const marketData = marketQuery.data ?? initialMarket;
  let t1;
  if ($[2] !== props.marketPubkey) {
    t1 = {
      pubkeys: props.marketPubkey
    };
    $[2] = props.marketPubkey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = marketData?.status === "graduated";
  let t3;
  if ($[4] !== t2) {
    t3 = {
      enabled: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const winners = useGetWinners(t1, t3);
  const t4 = winners.rows.length > 0;
  let t5;
  if ($[6] !== marketData || $[7] !== props.marketPubkey || $[8] !== t4 || $[9] !== winners.queryKey) {
    t5 = {
      marketPubkey: props.marketPubkey,
      market: marketData,
      winnerRowLoaded: t4,
      winnersQueryKey: winners.queryKey
    };
    $[6] = marketData;
    $[7] = props.marketPubkey;
    $[8] = t4;
    $[9] = winners.queryKey;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const resolutionHold = useResolutionHold(t5);
  const holding = resolutionHold === "holding";
  const heldMarket = useHeldWhile(marketData, holding);
  let t6;
  if ($[11] !== heldMarket || $[12] !== holding || $[13] !== marketData) {
    t6 = holding && heldMarket !== undefined ? {
      ...heldMarket,
      status: "trading" as const
    } : marketData;
    $[11] = heldMarket;
    $[12] = holding;
    $[13] = marketData;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const presentedMarket = t6;
  const t7 = marketData === undefined && marketQuery.isPending;
  let t8;
  if ($[15] !== holding || $[16] !== presentedMarket || $[17] !== props || $[18] !== t7) {
    t8 = <MarketDetailPositionBoundary {...props} marketData={presentedMarket} marketIsPending={t7} resolutionHolding={holding} />;
    $[15] = holding;
    $[16] = presentedMarket;
    $[17] = props;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}